import { render, staticRenderFns } from "./ClientEditTabDefaultOptions.vue?vue&type=template&id=3b77b5b4&"
import script from "./ClientEditTabDefaultOptions.vue?vue&type=script&lang=js&"
export * from "./ClientEditTabDefaultOptions.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditTabDefaultOptions.vue?vue&type=style&index=0&id=3b77b5b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports